import { render } from "./PaginationUI.vue?vue&type=template&id=3d4717fe&scoped=true"
import script from "./PaginationUI.vue?vue&type=script&lang=js"
export * from "./PaginationUI.vue?vue&type=script&lang=js"

import "./PaginationUI.vue?vue&type=style&index=0&id=3d4717fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4717fe"]])

export default __exports__